module.exports = __webpack_public_path__ + "static/media/food06.f1ef3647.jpg";